import { createFileRoute, redirect } from '@tanstack/react-router'
import { analytics, Dashboard } from 'merchant-components';
import { getCurrentAppState } from 'merchant-api/derived'
import { getPartiesOpts } from 'merchant-api/spiceroad'
import { applicationsOpts, unifiedApiClient } from 'merchant-api/unified'
import { isOptimizelyVariationEnabled, optimizelyVariationOptions, SCC_BRUTE_FORCE_FALLBACK_FLAG } from 'merchant-api/vendor/optimizely';
import { AppError } from 'merchant-api';

export const Route = createFileRoute('/_merchant/_portal/')({
  component: Dashboard,
  loader: async ({ context }) => {
    await unifiedApiClient.GET('/client/whoami');

    const variation =  await context.queryClient
      .ensureQueryData(optimizelyVariationOptions({
        featureKey: SCC_BRUTE_FORCE_FALLBACK_FLAG,
        analytics,
      }))
      .catch(() => null);

    if (isOptimizelyVariationEnabled(variation)) {
      const applications = await context.queryClient
        .fetchQuery(applicationsOpts({ statuses: ['APPROVED'] }))
        .catch(() => null);

      const isSccBruteForce =
        applications != null &&
        applications.length > 1 &&
        applications.some((application) => application.metadata?.channelCode === 'PARTNER_ISO');

      // if user is SCC Brute Force and doesn't arrive via unique checkout url, show fallback page
      if (isSccBruteForce)  throw AppError.CustomLinkRequired;
    }

    // Existing customers service their loan from the portal — never bounce them to the app wizard.
    const parties = await context.queryClient.fetchQuery(getPartiesOpts);
    if (parties?.parties?.some((party) => party.type === 'CUSTOMER')) return;

    const result = await getCurrentAppState({ statuses: ['APPROVED'] });
    if (!result) return;

    throw redirect({ to: `/application/$id/${result.state}`, params: { id: result.id } });
  }
});
